module.exports = {"ON_AUTHENTICATED":"onAuthenticated","ON_SESSION_END":"onSessionEnd","ON_SESSION_BEFORE_RECONNECT":"onSessionBeforeReconnect","ON_SESSION_RECONNECT":"onSessionReconnect","ON_LOGOUT":"onLogout","ON_READY":"onReady","INFRA_CHANNEL":"live_engage_infra","SESSION_VALIDATE_SUSTAIN_SOURCE":"session:validateSustainSource"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/common-constants-ids.json
// module id = 74
// module chunks = 0